module.exports = __webpack_public_path__ + "static/icon-b0827f1eb71e95a1d31f2a4afd85eec1.png";